import React, { useMemo } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import { UPLOAD_STATUS } from "../../../utils";
import { getUTCToLocalDateTime } from "../../../utils/date";

const headCells = ["File", "Status", "Uploaded By", "Uploaded On"];
const headCellsDataguide = [
  "File",
  "Status",
  "Downloaded/Uploaded By",
  "Downloaded/Uploaded On",
];

const StatusSx = (status) => ({
  color:
    status === UPLOAD_STATUS[0]
      ? (theme) => theme.palette.success.main
      : status === UPLOAD_STATUS[1]
      ? (theme) => theme.palette.error.main
      : (theme) => theme.palette.info.main,
});

const FileDetailsTable = (props) => {
  const { rows = [], isDataguide = false, isOSOItemList = false } = props;

  const tableHeader = useMemo(() => {
    let _value = null;
    if (isDataguide) {
      _value = headCellsDataguide;
    } else if (isOSOItemList) {
      _value = headCells;
    } else {
      _value = headCells;
    }
    return _value;
  }, [isDataguide, isOSOItemList]);

  return (
    <TableContainer
      component={Paper}
      sx={{ maxHeight: 290, maxWidth: 700, my: 2 }}
    >
      <Table
        stickyHeader
        sx={{ minWidth: 550 }}
        aria-label="File details table"
      >
        <TableHead>
          <TableRow>
            {tableHeader.map((headCell, i) => (
              <TableCell
                key={i}
                padding="none"
                sx={{
                  pl: 1,
                  py: 1,
                  fontWeight: "bold",
                  backgroundColor: "#E7E7E7",
                }}
              >
                {headCell}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, i) => (
            <TableRow
              hover
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              key={i}
            >
              <TableCell
                component="th"
                scope="row"
                sx={{
                  pl: 1,
                  display: "table-cell",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: 90,
                }}
              >
                <Tooltip title={row?.FileName ?? ""} arrow>
                  <Link href={row?.SignedURL}>{row?.FileName}</Link>
                </Tooltip>
              </TableCell>
              <TableCell
                component="th"
                scope="row"
                sx={{
                  pl: 1,
                  display: "table-cell",
                  maxWidth: 70,
                }}
              >
                {isDataguide || isOSOItemList ? (
                  <Typography variant="subtitle2" sx={StatusSx(row?.Status)}>
                    {row?.Status === UPLOAD_STATUS[1] ? "Failed" : row?.Status}
                  </Typography>
                ) : (
                  <Typography
                    variant="subtitle2"
                    sx={{
                      ...(row?.IsSuccess
                        ? { color: (theme) => theme.palette.success.main }
                        : { color: (theme) => theme.palette.error.main }),
                    }}
                  >
                    {row?.IsSuccess ? "Success" : "Failed"}
                  </Typography>
                )}
              </TableCell>
              <TableCell
                sx={{
                  pl: 1,
                  display: "table-cell",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: 120,
                }}
              >
                <Tooltip title={row?.UploadedBy ?? ""} arrow>
                  <span>{row?.UploadedBy}</span>
                </Tooltip>
              </TableCell>
              <TableCell
                sx={{
                  pl: 1,
                  display: "table-cell",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: 85,
                }}
              >
                {isDataguide || isOSOItemList ? (
                  <Tooltip
                    title={
                      getUTCToLocalDateTime(row?.UploadedDateTime).format(
                        "MM/DD/YYYY h:mmA"
                      ) ?? ""
                    }
                    arrow
                  >
                    <span>
                      {getUTCToLocalDateTime(row?.UploadedDateTime).format(
                        "MM/DD/YYYY h:mmA"
                      )}
                    </span>
                  </Tooltip>
                ) : (
                  <Tooltip
                    title={
                      getUTCToLocalDateTime(row?.CreatedDateTime).format(
                        "MM/DD/YYYY h:mmA"
                      ) ?? ""
                    }
                    arrow
                  >
                    <span>
                      {getUTCToLocalDateTime(row?.CreatedDateTime).format(
                        "MM/DD/YYYY h:mmA"
                      )}
                    </span>
                  </Tooltip>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default FileDetailsTable;
